// store.ts

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import candidateReducer from './slices/candidateSlice';
import jobReducer from './slices/jobSlice';
import resumeUploadReducer from './slices/resumeUploadSlice';
import jobApplicationReducer from './slices/jobApplicationSlice';

import candidateAnalysisReducer from './slices/candidateAnalyzerSlice';
import permissionsReducer from './slices/permissionSlice';
import notificationsReducer from './slices/notificationSlice'; 
import teamsMeetingsReducer from './slices/teamMeetingsSlice';
import pipelineStageReducer from './slices/pipelineStageSlice';
import offerReducer from './slices/offerSlice';
import projectsReducer from './slices/projectSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    candidate: candidateReducer,
    job: jobReducer,
    uploadResume: resumeUploadReducer,
    jobApplication: jobApplicationReducer,

    candidateAnalysis: candidateAnalysisReducer,
    permissions: permissionsReducer,
    notifications: notificationsReducer,
    teamsMeetings: teamsMeetingsReducer,
    pipelineStages: pipelineStageReducer,
    offers: offerReducer,
    projects: projectsReducer,
  },
  devTools: import.meta.env.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
